export default "__VITE_ASSET__CpqapSvg__"